var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDonut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6 16.8c0 1-.4 2.1-1 3-.6 1-1.5 1.7-2.5 2.1-1 .4-2.1.6-3.2.4-2.2-.4-4-2.2-4.4-4.4-.2-1.1 0-2.3.4-3.3a5.6 5.6 0 015-3.5h1.2V3.7H13a13 13 0 1013 13v-1h-7.4zm5.1 1A10.8 10.8 0 1112 6v3a7.8 7.8 0 00-6.5 9.6c.7 2.9 3 5.1 5.8 5.8 4.5 1.1 9-2 9.6-6.5zm-7-10.4c1.5 0 3 .6 4 1.6s1.5 2.5 1.5 4v1h7.5v-1a13 13 0 00-13-13h-1.3v7.4zm7.6-2c1.8 1.7 2.9 4 3.2 6.4h-3a7.7 7.7 0 00-6.7-6.5v-3c2.4.2 4.7 1.3 6.5 3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonut);
export default __webpack_public_path__ + "static/media/donut.35f6c701.svg";
export { ForwardRef as ReactComponent };